import {
  Accordion,
  ACTION_ICONS_NAMESPACE,
  ConfirmDialog,
  CustomButton,
  Loader,
  Modal,
  SearchBar,
  SkeletonLoader,
  SvgAssign,
  SvgCross,
  SvgEdit,
  SvgMECResend,
  SvgMECRevoke,
  TableActionType,
  Tooltip,
} from '@ui-kit'
import { noop, map as arrayKeyBy, isEmpty, omit } from 'lodash'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import {
  addToaster,
  createSubResource,
  DataTypeStore,
  MappedResponseData,
  ENTITY_TYPE,
  getLayoutByIdApi,
  getSubResources,
  hideLoader,
  LayoutResponseType,
  LayoutRowType,
  quarantineAePcIfRejectedApi,
  resendMECConsent,
  revokeMECConsent,
  showLoader,
  updateSubResource,
  fetchDuplicateRecordsAPI,
  getEntityDataByEntityFilter,
  getLayoutByEntityIdAndTypeApi,
  isValidEntityDataId,
  isValidLayout,
  setEntityDataForUsResident,
  transformToDuplicateApiPayload,
  WORKFLOW_UI_IDENTIFIER,
  MAX_RTE_CONSTANTS,
} from '@app-store'
import { EntityLayout, LayoutData, Page } from '../types/layout.types'
import FormRenderer from './FormRenderer'
import { createPortal } from 'react-dom'
import { FieldValues, useFormContext } from 'react-hook-form'
import { RootState, useAppDispatch, useAppSelector } from '../utils/agent.store'
import AddEditRecordPage from '../pages/AddEditViewRecord.page'
import {
  E_INCOME_LABEL_REGEX,
  ENTITY_NAME,
  FIELD_VALUE_CONSTANTS,
  HTTP_STATUS_CONSTANTS,
  LAYOUT_TYPE_NAMESPACE,
  MAX_RTE_DATE_CONSTANTS,
  MEC_RECORD_STATUSES,
  MODE_CONSTANTS,
  NAMESPACES,
  PERMISSION_MODULES,
  RECORD_STATE,
  TABLE_ACTIONS,
  WORKFLOW_STATUS,
} from '../utils/constants'
import {
  AddLookupModalPropsTypes,
  RowRenderTypes,
} from '../types/formRenderer.types'
import { hasPermission, isReadOnlyUser } from '../utils/permission'
import { ListingTable } from './listing-table/ListingTable'
import {
  ListingPopoutExpandButton,
  PopoutableListingShell,
} from './listing-table/PopoutableListingShell'
import { ListingTableProps, ListingTableRow } from '../types/listingTable.types'
import { TabIndexMap } from '../types/common'
import { generateTabIndexMap, getMaxTabIndexValue } from '../utils/tab-indexing'
import { ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS } from '../constants/form.constants'
import {
  enhanceWithState,
  removeParentKeyName,
  validatePhoneNumberAndAddress,
} from '../utils/form.utils'
import { applyLayoutDataConfigToPayload } from '../utils/multiLookupFilter.utils'
import { v4 as uuid } from 'uuid'
import { fetchCaseData, permissionObject } from '../utils/helperFunctions'
import {
  APPLICATION_PREFERENCES_STRINGS,
  DUPLICATION,
  EXPERIAN_STRINGS,
  ENTITIES_WITH_NO_ADD_BUTTON,
  MAX_RTE_STRINGS,
} from '../utils/strings'
import { Group } from '../types/types'
import { ListingTableColumn } from '../utils/types'
import { DuplicationScore } from './DuplicationScore'
import {
  editEntityDataEmbeddedAPI,
  getEntityData,
  getEntityDataByIdEmbedded,
} from '../apis/entityData.api'
import { fetchMacrosApi } from '../apis/contextual.api'
import { fetchInitialData, MAX_RTE_NAME_SPACE } from '../utils/maxRTE'

export const AddDataModal: React.FC<AddLookupModalPropsTypes> = ({
  children,
  formUniqueId = 'addDataModalPortalDiv',
}) => {
  const container = document.getElementById(formUniqueId)
  if (!container) {
    return null
  }
  return createPortal(children, container)
}

export const RowRender = ({
  // To add when subform will be used instead of ML
  mode,
  row,
  layout,
  dataId,
  formUniqueId,
  tabIndexMap,
  addTaskId,
  isTaskCompleted,
  task,
  fullLayout,
  isDefaultOpen = false,
  showSubTotal = false,
  parentKey = '',
  handleSubtotalChange,
  alwaysOpen = false,
  showEincome = false,
  handleEIncomeClick,
  subtotalkeys = [],
  isMinHeight = true,
  isAppealTask,
  ...rest
}: RowRenderTypes) => {
  const dispatch = useAppDispatch()
  const formContext = useFormContext()
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(isDefaultOpen)
  const [isListingPopoutOpen, setIsListingPopoutOpen] = useState(false)
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [editLayout, setEditLayout] = useState<LayoutResponseType>()
  const selectedUnassignedIds = useRef<Set<DataTypeStore['id']>>(
    new Set()
  ).current
  const rowKeyName = removeParentKeyName(row?.lookup_meta?.lookup_keyName ?? '')
  const entityId =
    layout?.layout_data?.added_fields?.[rowKeyName ?? 0]?.relationship
      ?.target_entity_id ?? 0
  const entityName =
    layout?.layout_data?.added_fields?.[rowKeyName ?? 0]?.relationship
      ?.target_entity ?? ''
  const [assignTableKey, setAssignTableKey] = useState(0)
  const [unAssignTableKey, setUnAssignTableKey] = useState(0)

  const [isAssignModalOpen, setIsAssignModalOpen] = useState<boolean>(false)
  const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false)
  const [selectedRecord, setSelectedRecord] = useState<DataTypeStore | null>(
    null
  )
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)
  const [lookupEntityID, setLookupEntityID] = useState<number | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false)
  const [deletedRow, setDeletedRow] = useState<DataTypeStore>({})
  const [tabIndexMapForAddModal, setTabIndexMapForAddModal] =
    useState<TabIndexMap>({})
  const hasViewPermission = useRef<boolean>(false)
  const hasEditPermission = useRef<boolean>(false)
  const hasCreatePermission = useRef<boolean>(false)
  const mustAddTabBuffer = tabIndexMap?.tabIndexOffset ?? 0
  const tabIndexes = tabIndexMap?.tabIndex
  const allEntities = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )
  const globalPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.globalPermissions
  )
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] =
    useState<boolean>(false)
  const entitiesByName = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )
  const caseData = useAppSelector((state) => state?.workflowData?.caseData)
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const isEInsuranceListing =
    rowKeyName === ENTITY_NAME.C_PATIENT_EINSURANCE_DETAILS_CASE &&
    task?.identifier?.sub_ui_identifier ===
      WORKFLOW_UI_IDENTIFIER.COMPLETE_E_ELIGIBILITY_SUB_UI_IDENTIFIER
  const categoryMap = useAppSelector(
    (state: RootState) => state.categoryDropdown?.categoryMap
  )
  const maxRteData = useAppSelector(
    (state: RootState) => state.maxRte.responseData
  )
  const shouldAutoScrollMaxRTE = useAppSelector(
    (state: RootState) => state.maxRte.shouldAutoScroll
  )
  const prevMaxRteDataRef = useRef(maxRteData)
  const [einsuranceCopyDataValue, setEinsuranceCopyDataValue] =
    useState<DataTypeStore | null>(null)
  const [einsuranceCopyEditLayout, setEinsuranceCopyEditLayout] =
    useState<LayoutResponseType>()
  const [einsuranceCopyIsLoading, setEinsuranceCopyIsLoading] =
    useState<boolean>(false)
  const [einsuranceCopyModalOpen, setEinsuranceCopyModalOpen] =
    useState<boolean>(false)
  const [einsuranceCopyTabIndexMap, setEinsuranceCopyTabIndexMap] =
    useState<TabIndexMap>({})
  const [einsuranceCopyConfig, setEinsuranceCopyConfig] = useState<{
    entityId: string
    entityName: string
    createLayoutId: string
    relationIdentifier: string
  }>({
    entityId: '',
    entityName: '',
    createLayoutId: '',
    relationIdentifier: '',
  })

  const fetchEinsuranceCopyEditLayout = async () => {
    try {
      setEinsuranceCopyIsLoading(true)
      const response = await getLayoutByIdApi({
        entityId: einsuranceCopyConfig.entityId,
        layoutId: einsuranceCopyConfig.createLayoutId,
      })
      setEinsuranceCopyEditLayout(response?.data)
    } catch (err) {
      console.error(err)
    } finally {
      setEinsuranceCopyIsLoading(false)
    }
  }

  const toggleEinsuranceCopyModal = (forceOpen?: boolean) => {
    const opening = forceOpen ?? !einsuranceCopyModalOpen
    setEinsuranceCopyModalOpen(opening)
    if (opening) {
      fetchEinsuranceCopyEditLayout()
    }
  }

  const resolvePatientIdFromCase = async (): Promise<number | undefined> => {
    try {
      if (!dataId) return undefined
      const patientResponse = await getEntityDataByIdEmbedded(
        workflowDefinition?.global_variables?.entity_name ?? '',
        Number(workflowDefinition?.global_variables?.entity_id),
        ['patient'],
        Number(dataId)
      )
      return patientResponse?.data?.patient?.id
    } catch (err) {
      console.log(err)
    }
  }

  const getMaxRteExternalTraceId = (
    row: DataTypeStore | MappedResponseData
  ): string | undefined => {
    const record = row as Record<string, string | undefined>
    return (
      record[MAX_RTE_CONSTANTS.KEYS.EXTERNAL_TRACE_ID] ??
      record.external_id ??
      record.extension_trace_id
    )
  }

  const mergeListingRowWithMaxRteData = (
    listingRow: DataTypeStore,
    maxRteRow: MappedResponseData
  ): DataTypeStore => {
    const { errors, ...restMaxRteRow } = maxRteRow
    return {
      ...listingRow,
      ...restMaxRteRow,
      ...(errors != null ? { errors } : {}),
    } as DataTypeStore
  }

  const resolveRowForMaxRteCopy = (
    listingRow: DataTypeStore
  ): DataTypeStore => {
    if (!maxRteData?.length) return listingRow
    const byId = maxRteData.find(
      (reduxRow) => reduxRow.id != null && reduxRow.id === listingRow.id
    )
    if (byId) return mergeListingRowWithMaxRteData(listingRow, byId)
    const listingTrace = getMaxRteExternalTraceId(listingRow)
    if (listingTrace) {
      const byTrace = maxRteData.find(
        (reduxRow) => getMaxRteExternalTraceId(reduxRow) === listingTrace
      )
      if (byTrace) return mergeListingRowWithMaxRteData(listingRow, byTrace)
    }
    return listingRow
  }

  const replicateToInsurance = async (row: DataTypeStore) => {
    try {
      let data: FieldValues = omit(row, 'id')
      const toDateOnly = (value: string) =>
        moment(
          value.replace(
            MAX_RTE_DATE_CONSTANTS.TIMEZONE_SUFFIX_STRIP_PATTERN,
            ''
          ),
          [...MAX_RTE_DATE_CONSTANTS.INPUT_PARSE_FORMATS]
        ).format(MAX_RTE_DATE_CONSTANTS.ISO_DATE_OUTPUT_FORMAT)
      if (data.eligibility_start_date) {
        data.effective_date = toDateOnly(String(data.eligibility_start_date))
      }
      if (data.eligibility_end_date) {
        data.expiration_date = toDateOnly(String(data.eligibility_end_date))
      }
      if (data.policy_rank_id) {
        data.policy_rank = {
          id: categoryMap?.['Payer Rank']?.filter(
            (val) => val?.value === data.policy_rank_id
          )?.[0]?.id,
        }
      }
      if (data.policy_status) {
        data.policy_status = {
          id: categoryMap?.['Policy Status']?.filter(
            (val) =>
              val?.value?.toLowerCase() === data.policy_status?.toLowerCase()
          )?.[0]?.id,
        }
      }
      if (data.policy_source_id) {
        data.policy_source = {
          id: categoryMap?.['Policy Source']?.filter(
            (val) =>
              val?.value?.toLowerCase() === data.policy_source_id?.toLowerCase()
          )?.[0]?.id,
        }
      }
      data = { ...data, payer: null, plan: null }
      dispatch(showLoader())
      setEinsuranceCopyDataValue(data)
      toggleEinsuranceCopyModal()
    } catch (err) {
      console.error(err)
      dispatch(
        addToaster({
          id: uuid(),
          message: MAX_RTE_STRINGS.REPLICATE_TO_INSURANCE_ERR,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleEinsuranceCopySubmit = async (values: FieldValues) => {
    try {
      dispatch(showLoader())
      const payload = {
        policy_status: values['policy_status'],
        payer: values['payer'],
        plan: values['plan'],
        pbm_name: values['pbm_name'],
        group_id: values['group_id'],
        subscriber_first_name: values['subscriber_first_name'],
        subscriber_employer: values['subscriber_employer'],
        policy_rank: values['policy_rank'],
        phone_pbm: values['phone_pbm'],
        rx_bin: values['rx_bin'],
        subscriber_dob: values['subscriber_dob'],
        subscriber_last_name: values['subscriber_last_name'],
        effective_date: values['effective_date'],
        policy_source: values['policy_source'],
        plan_phone: values['plan_phone'],
        rx_pcn: values['rx_pcn'],
        expiration_date: values['expiration_date'],
        policy_id: values['policy_id'],
        rx_group: values['rx_group'],
        benefits_list: values['benefits_list'],
      }
      // The destination relation is patient-scoped, but this row's own
      // dataId is the case id, so resolve the patient id first.
      const patientResponse = await getEntityDataByIdEmbedded(
        workflowDefinition?.global_variables?.entity_name ?? '',
        Number(workflowDefinition?.global_variables?.entity_id),
        ['patient'],
        Number(dataId)
      )
      const patientId = patientResponse?.data?.patient?.id

      const response = await createSubResource(
        einsuranceCopyConfig.entityName,
        einsuranceCopyConfig.entityId,
        einsuranceCopyConfig.createLayoutId,
        patientId?.toString() ?? '',
        einsuranceCopyConfig.relationIdentifier,
        payload
      )
      if (response) {
        document.dispatchEvent(new CustomEvent('maxRteEvent'))
        dispatch(
          addToaster({
            id: uuid(),
            message: MAX_RTE_STRINGS.APPROVE_TOASTER_MSG,
            type: 'success',
          })
        )
        setEinsuranceCopyModalOpen(false)
      } else {
        dispatch(
          addToaster({
            id: uuid(),
            message: MAX_RTE_STRINGS.REPLICATE_TO_INSURANCE_ERR,
            type: 'error',
          })
        )
      }
    } catch (e) {
      const err = e as {
        response?: { data?: { message?: string } }
        message?: string
      }
      const responseErrorMessage = err?.response?.data?.message
      const errorMessage = responseErrorMessage?.split('\n')[0]
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage ?? MAX_RTE_STRINGS.REPLICATE_TO_INSURANCE_ERR,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  const [selectedRow, setSelectedRow] = useState<ListingTableRow | null>(null)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [addedRecord, setAddedRecord] = useState<FieldValues | null>(null)
  const [duplicateListingLayout, setDuplicateListingLayout] =
    useState<LayoutResponseType>()
  const [refetchKey, setRefetchKey] = useState<number>(0)
  const [viewDuplicateRecord, setViewDuplicateRecord] = useState<boolean>(false)
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [viewRecordData, setViewRecordData] = useState<FieldValues>()

  const assignNewData = async (values: FieldValues) => {
    try {
      setIsLoading(true)
      const keyName = rowKeyName
      const entityName =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.target_entity
      const entityId =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.target_entity_id
      const layoutId =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.create_layout_id
      const relationIdentifier =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.relation_identifier
      const missingMiIdentifier = task?.identifier?.MI_LISTING_LAYOUT
      const uploadId = Number(values?.document_upload?.id)
      const hasValidUpload = Number.isFinite(uploadId) && uploadId > 0
      if (!hasValidUpload) {
        delete values.document_upload
      }
      if (
        entityName?.includes(ENTITY_NAME.CASE_DOCUMENTS_LOWER) &&
        hasValidUpload &&
        entitiesByName?.[ENTITY_NAME.AE_PC_DOCUMENT]?.queue_visibility
      ) {
        let programsId = caseData?.programs?.id
        if (!programsId) {
          const caseDataResponse = await fetchCaseData(dataId ?? '', dispatch)
          programsId = caseDataResponse?.data?.programs?.id
        }
        values.c_ae_pc_document = {
          c_cases: {
            id: Number(dataId),
            _state: RECORD_STATE.ADDED,
          },
          ...(values.case_document_type?.id
            ? {
                document_type: {
                  id: values.case_document_type.id,
                  _state: RECORD_STATE.ADDED,
                },
              }
            : {}),
          ...(values.document_upload?.id
            ? {
                documents: {
                  id: values.document_upload.id,
                  _state: RECORD_STATE.ADDED,
                },
              }
            : {}),
          ...(programsId
            ? {
                programs: {
                  id: programsId,
                  _state: RECORD_STATE.ADDED,
                },
              }
            : {}),
          _state: RECORD_STATE.ADDED,
        }
      }
      await createSubResource(
        entityName ?? '',
        entityId?.toString() ?? '',
        layoutId ?? '',
        dataId ?? '',
        relationIdentifier ?? '',
        values,
        missingMiIdentifier,
        task?.case_id
      )
      if (
        entityName?.includes(ENTITY_NAME.CASE_DOCUMENTS_LOWER) &&
        hasValidUpload
      ) {
        try {
          await quarantineAePcIfRejectedApi(uploadId)
        } catch (quarantineError) {
          console.error(quarantineError)
        }
      }
      fetchAssignedData()
      setIsAddModalOpen(false)
      if (row?.dependent_config) {
        fetchMacroForUsResident()
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      const responseErrorMessage = err?.response?.data?.message
      const errorMessage = responseErrorMessage.split('\n')[0]
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage ?? NAMESPACES?.SOMETHING_WENT_WRONG,
          type: 'error',
        })
      )
    } finally {
      setIsLoading(false)
    }
  }

  const unAssignData = async (
    newRow: DataTypeStore,
    tableRow?: DataTypeStore
  ) => {
    try {
      dispatch(showLoader())
      const keyName: string = rowKeyName ?? ''
      const finalValue: FieldValues = {}
      finalValue[keyName] = [newRow]
      finalValue['record_status'] = rest?.parentRecordStatus
      const entityId = layout?.entity_id
      const layoutId = layout?.id?.toString()
      await updateSubResource(
        entityId?.toString() || '',
        layoutId || '',
        dataId ?? '',
        finalValue,
        NAMESPACES.REMOVED
      )
      fetchAssignedData()
      if (tableRow?.is_preferred === 'true' && row?.dependent_config) {
        fetchMacroForUsResident()
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewLayout = async () => {
    dispatch(showLoader())
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: String(editLayout?.entity_id),
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res?.data?.[0])
        return res?.data?.[0]?.id
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewRecordData = async (layoutId: number, id: number) => {
    dispatch(showLoader())
    try {
      const res = await getEntityData(
        String(editLayout?.entity_name),
        Number(editLayout?.entity_id),
        layoutId,
        id
      )
      if (res?.data) {
        setViewRecordData(res?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const extraActions: (TableActionType<DataTypeStore> & {
    onClick?: (row: ListingTableRow, rowIndex: number) => void
  })[] = [
    {
      label: NAMESPACES.VIEW,
      key: ACTION_ICONS_NAMESPACE.VIEW,
      onClick: async (row) => {
        const layoutId = await fetchViewLayout()
        setSelectedRow(row)
        setViewDuplicateRecord(true)
        fetchViewRecordData(layoutId, row?.id)
      },
    },
  ]

  const extraColumn: ListingTableColumn[] = [
    {
      header: '',
      accessor: DUPLICATION.SELECT_ACCESSOR,
      type: DUPLICATION.RADIO_TYPE,
      onClick(_KeyName, row, _rowIndex) {
        setSelectedRow(row)
        setRefetchKey((prev) => prev + 1)
      },
    },
    {
      header: APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE,
      accessor: DUPLICATION.SCORE_ACCESSOR,
      type: DUPLICATION.COMPONENT_TYPE,
      renderComponent: (row) => {
        return (
          <div className="flex items-center gap-1">
            <span>{String(row?.score ?? '')}</span>
            <DuplicationScore
              groups={row?.matchDetails as unknown as Group[]}
            />
          </div>
        )
      },
    },
  ]

  const closeDuplicationModal = () => {
    setAddedRecord(null)
    setIsDuplicateModalOpen(false)
    setViewDuplicateRecord(false)
    setIsAddModalOpen(false)
    setSelectedRow(null)
    fetchAssignedData()
  }

  const createNewRecord = async (values?: FieldValues) => {
    dispatch(showLoader())
    try {
      const keyName = rowKeyName
      const entityName =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.target_entity
      const entityId =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.target_entity_id
      const layoutId =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.create_layout_id
      const relationIdentifier =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.relation_identifier
      const missingMiIdentifier = task?.identifier?.MI_LISTING_LAYOUT
      if (values && !addedRecord) {
        const flagValue = validatePhoneNumberAndAddress(values, dispatch)
        if (flagValue) {
          return
        }
        values = {
          ...enhanceWithState(values),
          _state: NAMESPACES.ADDED,
        }
      }
      await createSubResource(
        entityName ?? '',
        entityId?.toString() ?? '',
        layoutId ?? '',
        dataId ?? '',
        relationIdentifier ?? '',
        addedRecord ?? values ?? {},
        missingMiIdentifier,
        task?.case_id
      )
      closeDuplicationModal()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: editLayout?.entity_id.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })
      if (res?.data) {
        setDuplicateListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.log(err)
    }
  }

  const fetchTableDataCallback = async (
    values: FieldValues,
    listingLayoutId: string | number,
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    if (listingLayoutId) {
      const duplicateApiPayload = transformToDuplicateApiPayload(
        values,
        editLayout?.entity_id?.toString() ?? '',
        listingLayoutId?.toString(),
        editLayout ?? undefined
      )
      const res = await fetchDuplicateRecordsAPI(
        editLayout?.entity_id ?? 0,
        duplicateApiPayload,
        payload?.page as number,
        payload?.size as number
      )
      const addSelectedFlag = (data: ListingTableRow[]) => {
        return data.map((row) => ({
          ...row,
          select: row?.id === selectedRow?.id ? true : false,
        }))
      }
      res.data.content = addSelectedFlag(res?.data?.content)
      setTotalRecords(res?.data?.totalElements ?? 0)

      if (res?.data?.content.length !== 0) {
        setAddedRecord(values)
        setIsDuplicateModalOpen(true)
      } else {
        createNewRecord(values)
      }
      return res?.data
    }
  }

  const handleAssignNewData = async (
    finalvalues: FieldValues,
    _embedded: string[],
    originalFormData: FieldValues | undefined
  ) => {
    if (!editLayout) {
      return
    }
    dispatch(showLoader())
    try {
      let values = { ...finalvalues, ...originalFormData }
      const flagValue = validatePhoneNumberAndAddress(values, dispatch)
      if (flagValue) {
        return
      }
      values = {
        ...enhanceWithState(values),
        _state: NAMESPACES.ADDED,
      }
      const entity = entitiesByName[editLayout?.entity_name ?? '']
      if (entity?.is_duplicate) {
        const listingLayout = await fetchListingLayout()
        await fetchTableDataCallback(values, listingLayout?.id)
      } else {
        assignNewData(values)
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const toggleAssignModal = () => {
    setIsAddModalOpen(false)
    setIsAssignModalOpen((prev) => !prev)
    if (!isAssignModalOpen) {
      setIsAccordionOpen(true)
      fetchUnassignedData()
    } else {
      fetchAssignedData()
    }
  }

  const toggleAddModal = () => {
    setIsAssignModalOpen(false)
    setSelectedRecord(null)
    setIsAddModalOpen((prev) => !prev)
    if (!isAddModalOpen) {
      fetchEditLayout()
    }
  }

  const toggleConfirmModal = () => {
    setIsConfirmModalOpen((prev) => !prev)
    if (isConfirmModalOpen === false) {
      fetchAssignedData()
    }
  }

  const getRowField = (row: LayoutRowType, layout: EntityLayout) => {
    const lookupKeyName = row.lookup_meta?.lookup_keyName
    return lookupKeyName
      ? layout?.layout_data?.added_fields?.[lookupKeyName]
      : null
  }

  const isRowGlobal = (row: LayoutRowType, layout: EntityLayout) => {
    const field = getRowField(row, layout)
    return field?.source_type === NAMESPACES.GLOBAL_KEY
  }

  const isTaskOrCaseRow = (row: LayoutRowType, layout: EntityLayout) => {
    const field = getRowField(row, layout)
    if (!field) return false
    return (
      field.relationship?.target_entity?.includes('_cases_view') ||
      field.relationship?.target_entity?.includes('_tasks_view')
    )
  }

  const isEntityGlobal = (row: LayoutRowType) => {
    const entityKey = fullLayout?.entity_name
    const entity = allEntities[entityKey ?? '']
    if (isEmpty(row?.container_behavior)) {
      return entity?.source_type === NAMESPACES.GLOBAL_KEY
    } else {
      return (
        row?.container_behavior?.toUpperCase() ===
        NAMESPACES?.GLOBAL_KEY?.toUpperCase()
      )
    }
  }

  const hasGlobalPermission = () => {
    if (!isRowGlobal(row, layout) && isTaskOrCaseRow(row, layout)) return false
    if (!isEntityGlobal(row)) return true
    if (isEntityGlobal(row) && !isRowGlobal(row, layout)) return true
    return (
      isEntityGlobal(row) &&
      isRowGlobal(row, layout) &&
      permissionObject.Manage_Global_Schema(
        globalPermissions,
        PERMISSION_MODULES.MANAGE_GLOBAL_DATA
      )
    )
  }

  const isReadOnlyTable = !!row?.lookup_meta?.dont_show_add_button

  const canShowAddButton = (() => {
    const containsIncome = E_INCOME_LABEL_REGEX.test(row?.label ?? '')
    return (
      !showEincome &&
      !isReadOnlyTable &&
      !ENTITIES_WITH_NO_ADD_BUTTON.includes(entityName) &&
      !!dataId &&
      !isTaskCompleted &&
      allEntities[entityName ?? '']?.type !== ENTITY_TYPE.VIEW &&
      layout.type !== LAYOUT_TYPE_NAMESPACE.OVERVIEW_TYPE &&
      mode !== 'view' &&
      !containsIncome &&
      (hasGlobalPermission() ||
        (row?.lookup_meta?.lookup_keyName?.includes('plans') &&
          row?.lookup_meta?.lookup_keyName?.includes('payers')))
    )
  })()

  const renderAddButton = () => {
    if (!canShowAddButton) {
      return null
    }
    return (
      <CustomButton
        height="h-8"
        onClick={(e) => {
          if (isValidEntityDataId(dataId)) {
            e.stopPropagation()
            if (row?.lookup_meta?.is_assign) {
              toggleAssignModal()
            } else {
              toggleAddModal()
            }
          }
        }}
        onKeyDown={(e) => {
          if (e?.key === 'Enter') {
            e?.preventDefault()
            if (isValidEntityDataId(dataId)) {
              if (row?.lookup_meta?.is_assign) {
                toggleAssignModal()
              } else {
                toggleAddModal()
              }
            }
          }
        }}
        disabled={isReadOnlyUser()}
      >
        {NAMESPACES.ADD}
      </CustomButton>
    )
  }

  const getAccordionHeading = (label: string) => {
    return (
      <div className="flex items-center justify-between">
        <div className="flex gap-3 justify-between">
          <span className="font-primary">{label}</span>
          {isEntityGlobal(row) ? (
            <span
              className={`flex items-center ${
                isRowGlobal(row, layout)
                  ? 'bg-secondary-50 border-secondary-25'
                  : 'bg-progress-25 border-taskStatus-300'
              } border h-5 rounded-sm px-2 py-1 text-accent-600 text-xxs`}
            >
              {isRowGlobal(row, layout) ? NAMESPACES.GLOBAL : NAMESPACES.CLIENT}
            </span>
          ) : null}
        </div>
        <div className="flex gap-2 items-center">
          {isValidEntityDataId(dataId) && listingLayout ? (
            <ListingPopoutExpandButton
              onClick={() => {
                setIsListingPopoutOpen(true)
              }}
              disabled={isListingPopoutOpen}
            />
          ) : null}
          {showEincome && !isAppealTask && (
            <CustomButton
              onClick={handleEIncomeClick}
              disabled={task?.state !== WORKFLOW_STATUS?.OPEN}
            >
              {EXPERIAN_STRINGS.E_INCOME_BUTTON_TEXT}
            </CustomButton>
          )}
          {renderAddButton()}
        </div>
      </div>
    )
  }

  const fetchEntityListing = async (entityId: string, layoutId: string) => {
    try {
      if (layoutId) {
        const response = await getLayoutByIdApi({ entityId, layoutId })
        setListingLayout(response?.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchEditLayout = async () => {
    try {
      setIsLoading(true)
      const keyName = row?.lookup_meta?.lookup_keyName
      const entityId =
        layout?.layout_data?.added_fields?.[
          row?.lookup_meta?.lookup_keyName ?? 0
        ]?.relationship?.target_entity_id.toString() ?? ''

      const layoutId =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.create_layout_id ??
        ''
      const response = await getLayoutByIdApi({ entityId, layoutId })
      setEditLayout(response?.data)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchUnassignedDataCallback: ListingTableProps['dataFetchCallback'] =
    async (payload) => {
      const keyName = rowKeyName

      const layoutId =
        payload.layout_id && payload.layout_id !== -1
          ? payload.layout_id
          : layout?.layout_data?.added_fields?.[keyName ?? 0]
              ?.list_view_layout_id

      const response = await getSubResources(
        entityName || '',
        entityId?.toString() || '',
        layoutId?.toString() ?? '',
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.relation_identifier ?? '',
        true,
        dataId ?? '',
        +payload.page,
        +payload.size,
        undefined,
        payload.filters,
        payload.select,
        payload.related_entities,
        layout?.layout_data?.added_fields?.[rowKeyName ?? '']
          ?.function_parameters ?? listingLayout?.function_parameters
      )

      response?.data?.content?.forEach((row: DataTypeStore) => {
        row.selected = selectedUnassignedIds.has(row.id)
      })

      return response.data
    }

  const fetchAssignedData = () => {
    setAssignTableKey((key) => key + 1)
  }
  const fetchUnassignedData = () => {
    setUnAssignTableKey((key) => key + 1)
  }

  const fetchAssignedDataCallback: ListingTableProps['dataFetchCallback'] =
    async (payload) => {
      const keyName = rowKeyName
      if (addTaskId) {
        payload.filters[0].criteria.push({
          field_name: 'task_id',
          operation: 'LIKE',
          values: [addTaskId],
        })
      }
      if (showEincome) {
        if (payload.filters.length === 0) {
          payload.filters.push({ criteria: [] })
        }

        const firstFilter = payload.filters[0]
        firstFilter.criteria = Array.isArray(firstFilter.criteria)
          ? firstFilter.criteria
          : []

        firstFilter.criteria.push({
          direction: 'DESC',
          field_name: 'created_at',
        })
        payload.filters[0] = firstFilter
      }
      const layoutId =
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.list_view_layout_id

      applyLayoutDataConfigToPayload(
        payload,
        layout?.config,
        formContext?.getValues
      )

      const response = await getSubResources(
        entityName || '',
        entityId?.toString() || '',
        layoutId ?? '',
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.relation_identifier ?? '',
        false,
        dataId ?? '',
        +payload.page,
        +payload.size,
        undefined,
        payload.filters,
        payload.select,
        payload.related_entities,
        layout?.layout_data?.added_fields?.[rowKeyName ?? '']
          ?.function_parameters ?? listingLayout?.function_parameters
      )

      return response.data
    }

  const assignData = async () => {
    try {
      dispatch(showLoader())
      const value = Array.from(selectedUnassignedIds).map((id) => ({
        id,
        _state: 'ADDED',
      }))
      const keyName: string = rowKeyName ?? ''
      const finalValue: FieldValues = {}
      finalValue[keyName] = value
      finalValue['record_status'] = rest?.parentRecordStatus
      const entityId = layout?.entity_id
      const layoutId = layout?.id?.toString()
      const response = await updateSubResource(
        entityId?.toString() || '',
        layoutId || '',
        dataId ?? '',
        finalValue,
        NAMESPACES.CHANGED
      )
      if (response.status === HTTP_STATUS_CONSTANTS.SUCCESS) {
        toggleAssignModal()
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const deleteRow = (tableRow: DataTypeStore) => {
    if (tableRow) {
      const newRow = {
        id: tableRow.id,
        name: tableRow.name,
        _state: 'REMOVED',
      }
      unAssignData(newRow, tableRow)
      setIsConfirmModalOpen(false)
    }
  }

  const editRow = (tableRow: DataTypeStore) => {
    setIsEditModalOpen(true)
    setSelectedRecord(tableRow)
  }
  const resendConsent = async (tableRow: DataTypeStore) => {
    try {
      dispatch(showLoader())
      const response = await resendMECConsent(tableRow?.id?.toString() ?? '')
      if (response?.status === FIELD_VALUE_CONSTANTS.TWO_HUNDRED) {
        dispatch(
          addToaster({
            id: uuid(),
            message: NAMESPACES?.RESEND_MEC_CONSENT_SUCCESS_MSG,
            type: 'success',
          })
        )
        fetchAssignedData()
      }
    } catch (error) {
      console.error(error)
      dispatch(
        addToaster({
          id: uuid(),
          message: NAMESPACES?.RESEND_MEC_CONSENT_ERROR_MSG,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  const revokeConsent = async (tableRow: DataTypeStore) => {
    try {
      dispatch(showLoader())
      const response = await revokeMECConsent(tableRow?.id?.toString() ?? '')
      if (response?.status === FIELD_VALUE_CONSTANTS.TWO_HUNDRED) {
        dispatch(
          addToaster({
            id: uuid(),
            message: NAMESPACES?.REVOKE_MEC_CONSENT_SUCCESS_MSG,
            type: 'success',
          })
        )
        fetchAssignedData()
      }
    } catch (error) {
      console.error(error)
      dispatch(
        addToaster({
          id: uuid(),
          message: NAMESPACES?.REVOKE_MEC_CONSENT_ERROR_MSG,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const onSaveClick = (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e && e.preventDefault()
    setIsEditModalOpen(false)
    fetchAssignedData()
    if (row?.dependent_config) {
      fetchMacroForUsResident()
    }
  }

  const fetchMacroForUsResident = async () => {
    const macrosArray = arrayKeyBy(row?.dependent_config || [], 'macro')
    const respo = await fetchMacrosApi(
      'macros',
      dataId ? +dataId : 0,
      macrosArray
    )
    dispatch(
      setEntityDataForUsResident({
        key: 'us_resident' + dataId?.toString(),
        value: respo?.data?.[0]?.us_resident?.id ?? '',
      })
    )
  }

  const fetchMECActionStatus = (status: string, key: string) => {
    switch (status) {
      case MEC_RECORD_STATUSES.COMPLETED:
        return true
      case MEC_RECORD_STATUSES.REVOKED:
      case MEC_RECORD_STATUSES.EXPIRED:
        return key !== TABLE_ACTIONS.RESEND
      case MEC_RECORD_STATUSES.REQUESTED:
        return false
      default:
        return false
    }
  }

  const getActions = (): ListingTableProps['extraActions'] => {
    // eInsurance is a read-only (VIEW-type) source entity, so it's exempt
    // from the edit-permission/entity_type gate below - Copy doesn't edit
    // this row, it only reads it to create a record elsewhere. Only the
    // task carrying this sub_ui_identifier shows Copy - every other
    // rendering of this entity (e.g. the patient's own eInsurance panel)
    // is unaffected.
    if (isEInsuranceListing) {
      return [
        {
          label: MAX_RTE_NAME_SPACE.COPY,
          key: MAX_RTE_NAME_SPACE.COPY,
          renderActionComponent: (row) => {
            if (Array.isArray(row.errors) && row?.errors?.length) return null
            const isTaskOpen = task?.state === WORKFLOW_STATUS.OPEN
            return (
              <Tooltip content={MAX_RTE_NAME_SPACE.COPY}>
                <button
                  type="button"
                  disabled={!isTaskOpen}
                  className={`flex items-center justify-center font-normal text-xs w-[4.313rem] h-[1.75rem] rounded border border-primary-500 ${
                    isTaskOpen
                      ? 'cursor-pointer hover:bg-primary-100'
                      : 'cursor-not-allowed opacity-50'
                  }`}
                  onClick={() => {
                    if (!isTaskOpen) return
                    replicateToInsurance(
                      resolveRowForMaxRteCopy(row as DataTypeStore)
                    )
                  }}
                >
                  {MAX_RTE_NAME_SPACE.COPY}
                </button>
              </Tooltip>
            )
          },
        },
      ]
    }
    if (
      layout?.type !== LAYOUT_TYPE_NAMESPACE.OVERVIEW &&
      hasEditPermission.current &&
      listingLayout?.entity?.entity_type !== ENTITY_TYPE?.VIEW &&
      layout?.type !== LAYOUT_TYPE_NAMESPACE.OVERVIEW_TYPE
    ) {
      if (entityName === 'c_consent_requests') {
        return [
          {
            label: NAMESPACES.RESEND_BUTTON,
            key: TABLE_ACTIONS.RESEND,
            renderActionComponent: (row) => (
              <Tooltip content={NAMESPACES.RESEND_BUTTON}>
                <button
                  type="button"
                  disabled={fetchMECActionStatus(
                    (row?.request_status as string) ?? '',
                    TABLE_ACTIONS.RESEND
                  )}
                  className={
                    fetchMECActionStatus(
                      (row?.request_status as string) ?? '',
                      TABLE_ACTIONS.RESEND
                    )
                      ? 'cursor-not-allowed'
                      : 'cursor-pointer'
                  }
                  onClick={
                    fetchMECActionStatus(
                      (row?.request_status as string) ?? '',
                      TABLE_ACTIONS.RESEND
                    )
                      ? noop
                      : () => resendConsent(row)
                  }
                >
                  <SvgMECResend />
                </button>
              </Tooltip>
            ),
            tabIndex:
              (tabIndexes?.[`${row?.rowId}-${row.label}`?.replace(' ', '')] ??
                0) +
              mustAddTabBuffer +
              4,
          },
          {
            label: NAMESPACES.REVOKE_BUTTON,
            key: TABLE_ACTIONS.REVOKE,
            renderActionComponent: (row) => (
              <Tooltip content={NAMESPACES.REVOKE_BUTTON}>
                <button
                  type="button"
                  disabled={fetchMECActionStatus(
                    (row?.request_status as string) ?? '',
                    TABLE_ACTIONS.REVOKE
                  )}
                  className={
                    fetchMECActionStatus(
                      (row?.request_status as string) ?? '',
                      TABLE_ACTIONS.REVOKE
                    )
                      ? 'cursor-not-allowed'
                      : 'cursor-pointer'
                  }
                  onClick={
                    fetchMECActionStatus(
                      (row?.request_status as string) ?? '',
                      TABLE_ACTIONS.REVOKE
                    )
                      ? noop
                      : () => revokeConsent(row)
                  }
                >
                  <SvgMECRevoke />
                </button>
              </Tooltip>
            ),
            tabIndex:
              (tabIndexes?.[`${row?.rowId}-${row.label}`?.replace(' ', '')] ??
                0) +
              mustAddTabBuffer +
              4,
          },
        ]
      } else
        return [
          {
            label: NAMESPACES.EDIT_BUTTON,
            key: TABLE_ACTIONS.EDIT,
            icon: <SvgEdit />,
            onClick: (row) => {
              editRow(row)
            },
            tabIndex:
              (tabIndexes?.[`${row?.rowId}-${row.label}`?.replace(' ', '')] ??
                0) +
              mustAddTabBuffer +
              4,
          },
          {
            label: NAMESPACES.REMOVE_BUTTON,
            key: TABLE_ACTIONS.REMOVE,
            icon: <SvgCross />,
            onClick: (row) => {
              setDeletedRow(row)
              setIsConfirmModalOpen(true)
            },
            tabIndex:
              (tabIndexes?.[`${row?.rowId}-${row.label}`?.replace(' ', '')] ??
                0) +
              mustAddTabBuffer +
              4,
          },
        ]
    } else {
      return []
    }
  }

  const linkCaseWithPharmacy = async () => {
    try {
      dispatch(showLoader())
      const data = {
        [row?.lookup_meta?.lookup_keyName ?? '']: [
          {
            id: selectedRow?.id,
            _state: 'ADDED',
          },
        ],
      }
      await editEntityDataEmbeddedAPI('case', dataId ?? '', data, [
        row?.lookup_meta?.lookup_keyName ?? '',
      ])
      closeDuplicationModal()
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    if (!isEInsuranceListing) return
    const deriveInsuranceConfig = async () => {
      // The destination "Insurance Policy Information" relation isn't on
      // this lean, single-row layout. It's not part of the entity's base
      // schema either (confirmed: entitiesByName/getEntityById don't carry
      // it - added_fields for lookup relations are layout-specific, added
      // per-layout by whoever builds it) - so read it off the tenant's
      // default patient edit layout instead, resolved by entity+type
      // rather than a hardcoded layout id.
      let fieldConfig =
        layout?.layout_data?.added_fields?.[ENTITY_NAME.C_PATIENT_INSURANCES]
      if (!fieldConfig) {
        const referenceLayout = await getLayoutByEntityIdAndTypeApi({
          entityId: ENTITY_NAME.PATIENT_ENTITY_ID,
          type: LAYOUT_TYPE_NAMESPACE.VIEW_EDIT,
          isDefault: true,
        })
        fieldConfig =
          referenceLayout?.data?.[0]?.layout_data?.added_fields?.[
            ENTITY_NAME.C_PATIENT_INSURANCES
          ]
      }
      if (!fieldConfig) return
      setEinsuranceCopyConfig({
        entityId: (
          fieldConfig?.relationship?.target_entity_id ?? 0
        )?.toString(),
        entityName: fieldConfig?.relationship?.target_entity ?? '',
        createLayoutId: fieldConfig?.create_layout_id ?? '',
        relationIdentifier:
          fieldConfig?.relationship?.relation_identifier ?? '',
      })
    }
    deriveInsuranceConfig()
  }, [isEInsuranceListing, layout])

  useEffect(() => {
    if (einsuranceCopyModalOpen && einsuranceCopyEditLayout?.layout_data) {
      setEinsuranceCopyTabIndexMap(
        generateTabIndexMap(
          (einsuranceCopyEditLayout?.layout_data?.pages as unknown as Page[]) ??
            [],
          ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS
        )
      )
    }
  }, [einsuranceCopyEditLayout?.layout_data, einsuranceCopyModalOpen])

  useEffect(() => {
    const keyName = rowKeyName
    const lookupEntityId =
      layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
        ?.target_entity_id ?? ''

    hasViewPermission.current = hasPermission(
      MODE_CONSTANTS.VIEW,
      lookupEntityId
    )
    hasEditPermission.current = hasPermission(
      MODE_CONSTANTS.EDIT,
      lookupEntityId
    )
    hasCreatePermission.current = hasPermission(
      MODE_CONSTANTS.ADD,
      lookupEntityId
    )
  }, [])

  useEffect(() => {
    if (!isEInsuranceListing || !isAccordionOpen || !dataId) return
    let cancelled = false
    const ensureMaxRteDataLoaded = async () => {
      const patientId = await resolvePatientIdFromCase()
      if (cancelled || !patientId) return
      if (
        maxRteData === null ||
        (Array.isArray(maxRteData) && !maxRteData.length)
      ) {
        await fetchInitialData(patientId)
      }
      if (!cancelled) {
        fetchAssignedData()
      }
    }
    ensureMaxRteDataLoaded()
    return () => {
      cancelled = true
    }
  }, [isEInsuranceListing, isAccordionOpen, dataId])

  useEffect(() => {
    if (!isEInsuranceListing || !isAccordionOpen) return
    if (maxRteData === prevMaxRteDataRef.current) return
    prevMaxRteDataRef.current = maxRteData
    if (Array.isArray(maxRteData) && maxRteData.length > 0) {
      fetchAssignedData()
    }
  }, [maxRteData, isEInsuranceListing, isAccordionOpen])

  useEffect(() => {
    if (!isEInsuranceListing || !isAccordionOpen || !shouldAutoScrollMaxRTE) {
      return
    }
    fetchAssignedData()
  }, [shouldAutoScrollMaxRTE, isEInsuranceListing, isAccordionOpen])

  useEffect(() => {
    if (row && isAccordionOpen) {
      const listener = () => {
        const lookupKeyName = row?.lookup_meta?.lookup_keyName ?? ''

        if (lookupKeyName === ENTITY_NAME.C_PATIENT_INSURANCES) {
          fetchAssignedData()
        }
      }
      document.addEventListener('maxRteEvent', listener)
      return () => {
        document.removeEventListener('maxRteEvent', listener)
      }
    }
  }, [layout, isAccordionOpen, row])

  useEffect(() => {
    if (
      layout?.layout_data?.added_fields?.[row?.lookup_meta?.lookup_keyName ?? 0]
        ?.relationship?.target_entity_id &&
      isAccordionOpen
    ) {
      const keyName = row?.lookup_meta?.lookup_keyName
      fetchEntityListing(
        layout?.layout_data?.added_fields?.[
          row?.lookup_meta?.lookup_keyName ?? 0
        ]?.relationship?.target_entity_id.toString() ?? '',
        layout?.layout_data?.added_fields?.[keyName ?? 0]
          ?.list_view_layout_id ?? ''
      )
      setLookupEntityID(
        layout?.layout_data?.added_fields?.[keyName ?? 0]?.relationship
          ?.target_entity_id ?? -1
      )
    }
  }, [isAccordionOpen])

  // useEffect(() => {
  //   console.log('changed... layout', layout)
  // }, [layout])

  // useEffect(() => {
  //   console.log('changed... isEditModal', isEditModalOpen)
  // }, [isEditModalOpen])

  useEffect(() => {
    selectedUnassignedIds.clear()
  }, [isAssignModalOpen])

  useEffect(() => {
    if (isAddModalOpen) {
      setTabIndexMapForAddModal(
        generateTabIndexMap(
          (editLayout?.layout_data?.pages as unknown as Page[]) ?? [],
          ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS
        )
      )
    }
  }, [editLayout?.layout_data, isAddModalOpen])

  // To modify later when we use subform instead of multilookup
  // if (mode === MODE_CONSTANTS.ADD || !dataId) {
  //   return null
  // }

  useEffect(() => {
    if (isValidEntityDataId(dataId)) {
      fetchAssignedData()
    }
  }, [dataId])

  if (!isValidLayout(layout)) {
    return null
  }

  return (
    <>
      {isConfirmModalOpen && (
        <ConfirmDialog
          open={isConfirmModalOpen}
          message={NAMESPACES.UNASSIGN_CONFIRMATION}
          onConfirm={() => deleteRow(deletedRow)}
          onCancel={toggleConfirmModal}
        />
      )}
      {isAddModalOpen && (
        <AddDataModal formUniqueId={formUniqueId}>
          <div>
            <Modal
              isOpen={isAddModalOpen}
              closeModal={toggleAddModal}
              showCloseButton={false}
              width="min-w-[75vw] max-w-[98%]"
              isResizable
            >
              {isLoading ? (
                <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
              ) : (
                <div>
                  {editLayout &&
                  !isDuplicateModalOpen &&
                  !viewDuplicateRecord ? (
                    <FormRenderer
                      showPatentInformation={
                        !!(
                          editLayout?.entity_name?.toLowerCase() ===
                          'patient_insurances'
                        )
                      }
                      heading={
                        <div className="flex justify-between items-center pb-2">
                          <div className="flex items-center justify-between gap-4">
                            <span className="font-medium text-base font-primary">
                              Add {row?.label}
                            </span>
                          </div>
                          <div className="flex items-center justify-end gap-4">
                            <div className="flex items-center gap-3">
                              <div className="flex gap-3">
                                <CustomButton
                                  onClick={() => {
                                    setIsAddModalOpen(false)
                                  }}
                                  tabIndex={getMaxTabIndexValue({
                                    tabIndexMapForAddModal,
                                  })}
                                >
                                  <span>{NAMESPACES.CANCEL_BUTTON}</span>
                                </CustomButton>
                                <CustomButton
                                  isFilled
                                  type="submit"
                                  tabIndex={
                                    getMaxTabIndexValue({
                                      tabIndexMapForAddModal,
                                    }) + 1
                                  }
                                >
                                  <span>{NAMESPACES.SAVE_BUTTON}</span>
                                </CustomButton>
                              </div>
                              {/* TODO: Might be required later */}
                              {/* <div className="flex items-center gap-3">
                                <div className="cursor-pointer">
                                  <SvgCross
                                    onClick={toggleAddModal}
                                    tabIndex={
                                      ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS
                                    }
                                    onKeyDown={(e) => {
                                      if (
                                        e?.key === ShortcutKeys.Enter ||
                                        e?.key === ShortcutKeys.Space
                                      ) {
                                        toggleAddModal()
                                        e?.preventDefault()
                                      }
                                    }}
                                  />
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      }
                      fullLayout={editLayout as EntityLayout}
                      layout={editLayout?.layout_data as LayoutData}
                      mode={'add'}
                      handleFormSubmit={handleAssignNewData}
                      // footer={

                      // }
                      tabIndexMap={tabIndexMapForAddModal}
                      addTaskId={addTaskId}
                      data={selectedRecord ?? addedRecord ?? {}}
                    />
                  ) : isDuplicateModalOpen ? (
                    <div className="flex flex-col gap-2">
                      <div className="flex justify-between items-center">
                        <div>
                          <span
                            className="font-medium text-base font-primary cursor-pointer"
                            onClick={() => {
                              setViewDuplicateRecord(false)
                              setIsDuplicateModalOpen(false)
                              setSelectedRow(null)
                            }}
                          >
                            {`${NAMESPACES.ADD} ${editLayout?.layout_data?.pages?.[0]?.rows?.[0]?.label}`}
                          </span>
                          <span
                            className={`font-medium text-base font-primary cursor-pointer ${
                              !viewDuplicateRecord ? `text-primary-500` : ``
                            }`}
                            onClick={() => {
                              setViewDuplicateRecord(false)
                            }}
                          >
                            {` / ${APPLICATION_PREFERENCES_STRINGS?.DUPLICATE_HEADING}`}
                          </span>
                          {viewDuplicateRecord && (
                            <span className="font-medium text-base font-primary cursor-pointer text-primary-500">
                              {` / ${NAMESPACES.VIEW} ${editLayout?.layout_data?.pages?.[0]?.rows?.[0]?.label}`}
                            </span>
                          )}
                        </div>
                        <div className="flex gap-2">
                          <CustomButton isFilled onClick={createNewRecord}>
                            {APPLICATION_PREFERENCES_STRINGS?.CREATE_ANYWAY}
                          </CustomButton>
                          <CustomButton
                            isFilled
                            onClick={() => {
                              linkCaseWithPharmacy()
                            }}
                            disabled={isEmpty(selectedRow)}
                          >
                            {APPLICATION_PREFERENCES_STRINGS?.USE_EXISTING}
                          </CustomButton>
                        </div>
                      </div>
                      {!viewDuplicateRecord ? (
                        <>
                          <span className="font-light text-xs pb-2">
                            {totalRecords}{' '}
                            {APPLICATION_PREFERENCES_STRINGS.RECORDS_FOUND}
                          </span>
                          <ListingTable
                            isMultiLookup={true}
                            entityId={Number(editLayout?.entity_id)}
                            entityName={editLayout?.entity_name ?? ''}
                            extraActions={extraActions}
                            layout={duplicateListingLayout}
                            dataFetchCallback={(payload) =>
                              fetchTableDataCallback(
                                addedRecord ?? {},
                                listingLayout?.id ?? 0,
                                payload
                              )
                            }
                            extraColumns={extraColumn}
                            hideFilters={true}
                            refetchKey={refetchKey}
                            openInNewTab={true}
                            elementMetaData={
                              layout?.layout_data?.added_fields?.[
                                rowKeyName ?? ''
                              ]
                            }
                          />
                        </>
                      ) : (
                        <FormRenderer
                          heading={null}
                          layout={viewLayout?.layout_data as LayoutData}
                          mode={MODE_CONSTANTS?.VIEW}
                          handleFormSubmit={noop}
                          fullLayout={viewLayout as EntityLayout}
                          data={viewRecordData}
                        />
                      )}
                    </div>
                  ) : null}
                </div>
              )}
            </Modal>
          </div>
        </AddDataModal>
      )}
      {isAssignModalOpen && (
        <div>
          <Modal
            isOpen={isAssignModalOpen}
            closeModal={toggleAssignModal}
            showCloseButton={false}
            width="min-w-[75vw] max-w-[98%]"
            isResizable
            minResizeWidth={654}
            bodyCssClassName="h-[30rem]"
            minResizeHeight={220}
          >
            {isLoading ? (
              <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
            ) : null}
            {
              <div
                className={`${
                  isLoading ? 'hidden' : ''
                } w-full h-full flex flex-col`}
              >
                {' '}
                <div className="flex items-center justify-between gap-4 font-primary">
                  <span className="font-medium text-base">
                    Assign {row?.label}
                  </span>
                  <div className="flex items-center gap-4">
                    <SearchBar
                      onSearch={noop}
                      showFunnel={false}
                      height="h-10"
                      width="w-44"
                    />
                    <CustomButton onClick={toggleAssignModal}>
                      <span>{NAMESPACES.CANCEL_BUTTON}</span>
                    </CustomButton>
                    {isEntityGlobal(row) && isRowGlobal(row, layout) ? null : (
                      <CustomButton onClick={toggleAddModal}>
                        <div className="flex items-center justify-center gap-1">
                          <SvgAssign className="svg-path-fill-primary-500 fill-primary-500" />
                          {/* <SvgPlus className="stroke-primary-500" /> */}
                          <span className="text-accent-900 font-light text-xs">
                            {NAMESPACES.ADD}
                          </span>
                        </div>
                      </CustomButton>
                    )}
                    <CustomButton isFilled onClick={assignData}>
                      <span>{NAMESPACES.CONFIRM}</span>
                    </CustomButton>
                    <div className="cursor-pointer w-[0.875rem] h-[0.875rem]">
                      <SvgCross
                        onClick={toggleAssignModal}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e?.key === 'Enter' || e?.key === ' ')
                            toggleAssignModal()
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="pt-4 font-medium font-primary flex-1 min-h-0">
                  <ListingTable
                    isMultiLookup={true}
                    refetchKey={unAssignTableKey}
                    entityId={entityId}
                    entityName={entityName}
                    dataFetchCallback={fetchUnassignedDataCallback}
                    extraColumns={[
                      {
                        accessor: 'selected',
                        type: 'checkbox',
                        onClick: (accessor, row) => {
                          row[accessor] = !row[accessor]
                          if (selectedUnassignedIds.has(row.id))
                            selectedUnassignedIds.delete(row.id)
                          else selectedUnassignedIds.add(row.id)
                        },
                      },
                    ]}
                    haltActions={isTaskCompleted}
                    showSubTotal={showSubTotal}
                    subTotalCols={subtotalkeys ?? row?.meta?.subtotalkeys ?? []}
                    parentKey={parentKey}
                    handleSubtotalChange={handleSubtotalChange}
                    alwaysOpen={!!alwaysOpen}
                    showStringFilterOptions={true}
                    dataId={dataId}
                    relationIdentifier={
                      layout?.layout_data?.added_fields?.[rowKeyName ?? 0]
                        ?.relationship?.relation_identifier ?? ''
                    }
                    elementMetaData={
                      layout?.layout_data?.added_fields?.[rowKeyName ?? '']
                    }
                    minHeight="7rem"
                  />
                </div>
                {/* TODO: Might be required later */}
                {/* <div className="flex pt-10 gap-3 justify-end"> */}
                {/* <CustomButton onClick={toggleAssignModal}>
                    <span>{NAMESPACES.CANCEL_BUTTON}</span>
                  </CustomButton>
                  <CustomButton isFilled onClick={assignData}>
                    <span>{NAMESPACES.CONFIRM}</span>
                  </CustomButton> */}
                {/* </div> */}
              </div>
            }
          </Modal>
        </div>
      )}
      {isEditModalOpen && (
        <AddDataModal formUniqueId={formUniqueId}>
          <div>
            <Modal
              isOpen={isEditModalOpen}
              closeModal={() => setIsAddModalOpen(false)}
              showCloseButton={false}
              width="min-w-[75vw]  max-w-[98%]"
              isResizable
            >
              <div className="flex">
                <div className="w-full">
                  {/* //done */}
                  <AddEditRecordPage
                    mode="edit"
                    entityId={lookupEntityID?.toString()}
                    id={selectedRecord?.id?.toString() ?? ''}
                    loaderVisible={false}
                    allowNavigate={false}
                    onSaveClick={onSaveClick}
                    shouldModalOpen={false}
                    onCancel={() => {
                      setIsEditModalOpen(false)
                      fetchAssignedData()
                    }}
                    layoutId={
                      layout?.layout_data?.added_fields?.[rowKeyName ?? 0]
                        ?.create_layout_id ?? undefined
                    }
                    // showFooter={true}
                  />
                </div>
                {/* <div className="flex flex-col cursor-pointer justify-start absolute top-4 right-4">
                  <div
                    className="p-2 ml-1"
                    onClick={() => {
                      setIsEditModalOpen(false)
                      fetchAssignedData()
                    }}
                  >
                    <SvgCross />
                  </div>
                </div> */}
              </div>
            </Modal>
          </div>
        </AddDataModal>
      )}
      <div>
        {row?.rowType ? (
          <div>
            <Accordion
              heading={getAccordionHeading(row?.label ?? '')}
              // borderColor="primary-500"
              isDefaultActive={isDefaultOpen}
              // isDisabled={!hasViewPermission.current}
              alwaysOpen={alwaysOpen}
              handleAccordionClick={(accordionExpanded) => {
                if (isListingPopoutOpen && !accordionExpanded) {
                  return
                }
                setIsAccordionOpen(accordionExpanded)
              }}
            >
              <div className="px-3 py-2 w-full">
                {!isValidEntityDataId(dataId) ? (
                  <div className="flex justify-center items-center h-full m-auto font-primary text-center  min-h-20">
                    <span>{NAMESPACES?.ADD_MODE_MULTILOOKUP}</span>
                  </div>
                ) : listingLayout ? (
                  <PopoutableListingShell
                    isOpen={isListingPopoutOpen}
                    onClose={() => setIsListingPopoutOpen(false)}
                    title={row?.label ?? ''}
                    headerActions={renderAddButton()}
                    disableFocusTrap={
                      isAddModalOpen ||
                      isEditModalOpen ||
                      isAssignModalOpen ||
                      isConfirmModalOpen ||
                      isDuplicateModalOpen
                    }
                  >
                    <ListingTable
                      isMultiLookup={true}
                      refetchKey={assignTableKey}
                      entityId={entityId}
                      entityName={entityName}
                      layout={listingLayout}
                      dataFetchCallback={fetchAssignedDataCallback}
                      extraActions={
                        isReadOnlyTable ||
                        isReadOnlyUser() ||
                        !hasGlobalPermission() ||
                        (row?.label && E_INCOME_LABEL_REGEX.test(row?.label))
                          ? []
                          : getActions()
                      }
                      noDataScreen={NoDataScreen}
                      tabIndex={
                        (tabIndexes?.[
                          `${row?.rowId}-${row.label}`?.replace(' ', '')
                        ] ?? 0) +
                        mustAddTabBuffer +
                        4
                      }
                      hideFilters={!!row?.lookup_meta?.disable_filters}
                      haltActions={isTaskCompleted || showEincome}
                      showSubTotal={showSubTotal}
                      subTotalCols={
                        subtotalkeys ?? row?.meta?.subtotalkeys ?? []
                      }
                      parentKey={parentKey}
                      handleSubtotalChange={handleSubtotalChange}
                      alwaysOpen={!!alwaysOpen}
                      showStringFilterOptions={true}
                      dataId={dataId}
                      relationIdentifier={
                        layout?.layout_data?.added_fields?.[rowKeyName ?? 0]
                          ?.relationship?.relation_identifier ?? ''
                      }
                      isMinHeight={isMinHeight}
                      minHeight={isListingPopoutOpen ? '7rem' : undefined}
                    />
                  </PopoutableListingShell>
                ) : (
                  <SkeletonLoader />
                )}
              </div>
            </Accordion>
          </div>
        ) : null}
      </div>
      {isEInsuranceListing &&
        einsuranceCopyModalOpen &&
        einsuranceCopyDataValue && (
          <AddDataModal>
            <Modal
              isOpen={einsuranceCopyModalOpen}
              closeModal={() => toggleEinsuranceCopyModal()}
              showCloseButton={false}
              width="min-w-[75vw] max-w-[70%]"
              isDragable={true}
            >
              {einsuranceCopyIsLoading ? (
                <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
              ) : (
                <div>
                  {einsuranceCopyEditLayout ? (
                    <FormRenderer
                      heading={
                        <div className="flex items-center justify-between gap-4">
                          <span className="font-medium text-base">
                            {
                              MAX_RTE_NAME_SPACE.ADD_INSURANCE_POLICY_INFORMATION
                            }
                          </span>
                          <div className="flex items-center gap-3">
                            <div className="cursor-pointer">
                              <SvgCross
                                onClick={() => toggleEinsuranceCopyModal()}
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e?.key === 'Enter' || e?.key === ' ') {
                                    toggleEinsuranceCopyModal()
                                    e?.preventDefault()
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      }
                      fullLayout={einsuranceCopyEditLayout as EntityLayout}
                      layout={
                        einsuranceCopyEditLayout?.layout_data as LayoutData
                      }
                      mode={'add'}
                      data={einsuranceCopyDataValue}
                      handleFormSubmit={handleEinsuranceCopySubmit}
                      footer={
                        <div className="flex items-center justify-end gap-4 mt-4">
                          <div className="flex items-center gap-3">
                            <div className="flex gap-3">
                              <CustomButton
                                onClick={() =>
                                  setEinsuranceCopyModalOpen(false)
                                }
                                tabIndex={getMaxTabIndexValue({
                                  tabIndexMapForAddModal:
                                    einsuranceCopyTabIndexMap,
                                })}
                              >
                                <span>{NAMESPACES.CANCEL_BUTTON}</span>
                              </CustomButton>
                              <CustomButton
                                isFilled
                                type="submit"
                                tabIndex={
                                  getMaxTabIndexValue({
                                    tabIndexMapForAddModal:
                                      einsuranceCopyTabIndexMap,
                                  }) + 1
                                }
                              >
                                <span>{NAMESPACES.SAVE_BUTTON}</span>
                              </CustomButton>
                            </div>
                          </div>
                        </div>
                      }
                      tabIndexMap={einsuranceCopyTabIndexMap}
                    />
                  ) : null}
                </div>
              )}
            </Modal>
          </AddDataModal>
        )}
    </>
  )
}
const NoDataScreen = () => {
  return (
    <div className="flex justify-center items-center h-full m-auto font-primary text-center  min-h-20">
      <span>{NAMESPACES.EMPTY_DATA_MULTILOOKUP}</span>
    </div>
  )
}
